export default __webpack_public_path__ + "static/media/meta_logo.cd350b59.svg";